(() => {
  const REVIEW_KEYWORD = "review";
  const EXTRA_SCROLL_GAP = 100;
  const LOOX_SOURCE_ID = "looxReviews";
  const LOOX_SOURCE_ATTR = "data-loox-source-id";
  const LOOX_CLONE_ATTR = "data-loox-clone-for";
  let lastLooxRefreshAt = 0;

  function textIncludesReview(text) {
    return (text || "").toLowerCase().includes(REVIEW_KEYWORD);
  }

  function handleize(value) {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }

    return value.replace(/"/g, '\\"');
  }

  function getCandidateIds(targetId) {
    if (!targetId) return [];
    const cleanId = targetId.trim().replace(/^#/, "");
    if (!cleanId) return [];
    const handleizedId = handleize(cleanId);
    const idsToTry = [];
    if (cleanId) idsToTry.push(cleanId);
    if (handleizedId && handleizedId !== cleanId) idsToTry.push(handleizedId);
    return idsToTry;
  }

  function isVisible(element) {
    return !!(
      element &&
      element.getClientRects().length > 0 &&
      window.getComputedStyle(element).display !== "none" &&
      window.getComputedStyle(element).visibility !== "hidden"
    );
  }

  function getVisibleSectionLayouts() {
    return [...document.querySelectorAll(".product-tabs__layout")].filter(isVisible);
  }

  function getReviewMount(preferredElement) {
    const preferredDetailsMount = preferredElement?.closest?.("details")?.querySelector("[data-review-mount]");
    if (preferredDetailsMount) return preferredDetailsMount;

    const preferredLayoutMount = preferredElement?.closest?.(".product-tabs__layout")?.querySelector("[data-review-mount]");
    if (preferredLayoutMount) return preferredLayoutMount;

    for (const layout of getVisibleSectionLayouts()) {
      const visibleMount = layout.querySelector("[data-review-mount]");
      if (visibleMount) return visibleMount;
    }

    return null;
  }

  function mountLooxReview(preferredElement) {
    const reviewContent = document.getElementById(LOOX_SOURCE_ID);
    const reviewMount = getReviewMount(preferredElement);
    if (!reviewContent || !reviewMount || reviewMount.contains(reviewContent)) return;

    reviewMount.appendChild(reviewContent);
  }

  function syncReviewAccordionHeight(preferredElement) {
    const details = preferredElement?.closest?.("details.is-active");
    const body = details?.querySelector(".accordion__body");
    if (!body || body.style.height === "auto") return;

    body.style.height = `${body.scrollHeight}px`;
  }

  function getLooxReviewTargets() {
    return [...document.querySelectorAll(
      `.product-tabs__layout #${LOOX_SOURCE_ID}, .product-tabs__layout [${LOOX_SOURCE_ATTR}="${LOOX_SOURCE_ID}"], .product-tabs__layout [${LOOX_CLONE_ATTR}="${LOOX_SOURCE_ID}"]`
    )];
  }

  function findLooxTargetInLayout(layout) {
    return layout?.querySelector(
      `#${LOOX_SOURCE_ID}, [${LOOX_SOURCE_ATTR}="${LOOX_SOURCE_ID}"], [${LOOX_CLONE_ATTR}="${LOOX_SOURCE_ID}"]`
    );
  }

  function getPreferredLooxTarget(preferredElement, reviewTargets) {
    const preferredLayout = preferredElement?.closest?.(".product-tabs__layout");
    const preferredTarget = findLooxTargetInLayout(preferredLayout);
    if (preferredTarget) return preferredTarget;

    for (const layout of getVisibleSectionLayouts()) {
      const visibleTarget = findLooxTargetInLayout(layout);
      if (visibleTarget) return visibleTarget;
    }

    return document.getElementById(LOOX_SOURCE_ID) || reviewTargets.find((target) => target.innerHTML.trim()) || reviewTargets[0];
  }

  function normalizeLooxReviewTargets(preferredElement) {
    const reviewTargets = getLooxReviewTargets();
    if (!reviewTargets.length) return;

    const currentSource = document.getElementById(LOOX_SOURCE_ID);
    const sourceTarget = getPreferredLooxTarget(preferredElement, reviewTargets);

    if (
      currentSource &&
      sourceTarget &&
      currentSource !== sourceTarget &&
      currentSource.innerHTML.trim() &&
      !sourceTarget.innerHTML.trim()
    ) {
      sourceTarget.innerHTML = currentSource.innerHTML;
    }

    reviewTargets.forEach((target) => {
      target.setAttribute(LOOX_SOURCE_ATTR, LOOX_SOURCE_ID);

      if (target === sourceTarget) {
        target.id = LOOX_SOURCE_ID;
        target.removeAttribute(LOOX_CLONE_ATTR);
        return;
      }

      target.removeAttribute("id");
      target.setAttribute(LOOX_CLONE_ATTR, LOOX_SOURCE_ID);
    });
  }

  function syncLooxClones() {
    const source = document.getElementById(LOOX_SOURCE_ID);
    if (!source || !source.innerHTML.trim()) return false;

    document.querySelectorAll(`[${LOOX_CLONE_ATTR}="${LOOX_SOURCE_ID}"]`).forEach((clone) => {
      if (clone.innerHTML === source.innerHTML) return;
      clone.innerHTML = source.innerHTML;
    });

    return true;
  }

  function hasLooxContent() {
    const source = document.getElementById(LOOX_SOURCE_ID);
    return !!source?.innerHTML.trim();
  }

  function restoreScrollPosition(scrollY) {
    if (typeof scrollY !== "number") return;
    if (Math.abs(window.scrollY - scrollY) < 20) return;
    window.scrollTo({ top: scrollY, behavior: "auto" });
  }

  function keepElementPosition(element, initialTop) {
    if (!element || typeof initialTop !== "number") return;

    const restore = () => {
      if (!element.isConnected) return;

      const currentTop = element.getBoundingClientRect().top;
      const delta = currentTop - initialTop;
      if (Math.abs(delta) < 20) return;

      window.scrollBy({ top: delta, behavior: "auto" });
    };

    requestAnimationFrame(restore);
    [100, 300, 700, 1200, 2200, 3200].forEach((delay) => {
      setTimeout(restore, delay);
    });
  }

  function refreshLooxReviews(preferredElement) {
    mountLooxReview(preferredElement);
    syncReviewAccordionHeight(preferredElement);
    normalizeLooxReviewTargets(preferredElement);
    if (syncLooxClones()) return;

    const now = Date.now();
    if (now - lastLooxRefreshAt < 2500) return;
    lastLooxRefreshAt = now;

    const refreshCallbacks = [
      window.Loox?.refreshWidgets,
      window.Loox?.refresh,
      window.Loox?.init,
      window.loox?.refreshWidgets,
      window.loox?.refresh,
      window.loox?.init
    ];

    const callback = refreshCallbacks.find((refreshCallback) => typeof refreshCallback === "function");

    if (callback) {
      try {
        callback();
      } catch (error) {
        // Ignore optional third-party refresh failures.
      }
    }

    setTimeout(syncLooxClones, 500);
    setTimeout(syncLooxClones, 1500);
    setTimeout(() => syncReviewAccordionHeight(preferredElement), 100);
    setTimeout(() => syncReviewAccordionHeight(preferredElement), 600);
    setTimeout(() => syncReviewAccordionHeight(preferredElement), 1600);
  }

  function scheduleLooxRefresh(preferredElement, preserveScroll = false) {
    const scrollY = preserveScroll ? window.scrollY : null;
    const restoreIfNeeded = () => restoreScrollPosition(scrollY);

    requestAnimationFrame(() => {
      mountLooxReview(preferredElement);
      syncReviewAccordionHeight(preferredElement);
      normalizeLooxReviewTargets(preferredElement);
      if (syncLooxClones() || hasLooxContent()) {
        restoreIfNeeded();
        return;
      }
      refreshLooxReviews(preferredElement);
      restoreIfNeeded();
    });
    setTimeout(() => {
      mountLooxReview(preferredElement);
      syncReviewAccordionHeight(preferredElement);
      if (syncLooxClones() || hasLooxContent()) {
        restoreIfNeeded();
        return;
      }
      refreshLooxReviews(preferredElement);
      restoreIfNeeded();
    }, 450);

    if (preserveScroll) {
      setTimeout(restoreIfNeeded, 100);
      setTimeout(restoreIfNeeded, 900);
      setTimeout(restoreIfNeeded, 1800);
    }
  }

  function isReviewControl(control) {
    if (!control) return false;

    const details = control.closest("details");
    const targetId = control.getAttribute("aria-controls") || details?.dataset.tabId || "";

    return (
      textIncludesReview(control.textContent) ||
      textIncludesReview(targetId) ||
      textIncludesReview(details?.dataset.tabLabel)
    );
  }

  function getSectionAccordionSummaryById(ids) {
    for (const layout of getVisibleSectionLayouts()) {
      for (const id of ids) {
        const details = layout.querySelector(`.product-tabs__accordion details[data-tab-id="${escapeSelector(id)}"]`);
        if (details) return details.querySelector("summary.js-btn");
      }
    }

    return null;
  }

  function getSectionAccordionSummaryByText() {
    for (const layout of getVisibleSectionLayouts()) {
      const summaries = layout.querySelectorAll(".product-tabs__accordion summary.js-btn");
      const reviewSummary = [...summaries].find((summary) =>
        textIncludesReview(summary.textContent)
      );

      if (reviewSummary) return reviewSummary;
    }

    return null;
  }

  function openAccordionSummary(summary) {
    if (!summary) return false;

    const details = summary.closest("details");
    const accordion = summary.closest("accordion-default");
    const body = summary.nextElementSibling;
    if (!details || !body) return false;

    accordion?.querySelectorAll("details.is-active").forEach((activeDetails) => {
      if (activeDetails === details) return;
      const activeSummary = activeDetails.querySelector("summary");
      const activeBody = activeSummary?.nextElementSibling;
      activeDetails.classList.remove("is-active");
      activeDetails.removeAttribute("open");
      activeSummary?.setAttribute("aria-expanded", "false");
      if (activeBody) activeBody.style.height = "0px";
    });

    details.classList.add("is-active");
    details.setAttribute("open", "");
    summary.setAttribute("aria-expanded", "true");
    body.style.height = "auto";
    scheduleLooxRefresh(summary);

    return true;
  }

  function activateTabsById(ids) {
    let activated = false;

    ids.forEach((id) => {
      const triggerInProductInfo = document.querySelector(`product-tabs .product__tab--trigger[data-tab="${id}"]`);
      if (triggerInProductInfo) {
        triggerInProductInfo.click();
        activated = true;
      }

      const triggerInSectionTabs = getVisibleSectionLayouts()
        .map((layout) => layout.querySelector(`.product-tabs__tab[aria-controls="${escapeSelector(id)}"]`))
        .find(Boolean);
      if (triggerInSectionTabs) {
        triggerInSectionTabs.click();
        scheduleLooxRefresh(triggerInSectionTabs);
        activated = true;
      }

      const accordionSummary = getSectionAccordionSummaryById([id]);
      if (openAccordionSummary(accordionSummary)) {
        activated = true;
      }
    });

    return activated;
  }

  function findTargetElement(ids) {
    for (const id of ids) {
      const target = document.getElementById(id);
      if (target) return target;
    }
    return null;
  }

  function findHeadingAnchor(ids) {
    for (const id of ids) {
      const triggerInProductInfo = document.querySelector(`product-tabs .product__tab--trigger[data-tab="${id}"]`);
      if (triggerInProductInfo) {
        return triggerInProductInfo.closest(".product__tabs") || triggerInProductInfo;
      }

      const triggerInSectionTabs = getVisibleSectionLayouts()
        .map((layout) => layout.querySelector(`.product-tabs__tab[aria-controls="${escapeSelector(id)}"]`))
        .find(Boolean);
      if (triggerInSectionTabs) {
        return triggerInSectionTabs.closest(".product-tabs__tabs") || triggerInSectionTabs;
      }

      const accordionSummary = getSectionAccordionSummaryById([id]);
      if (accordionSummary) {
        return accordionSummary;
      }
    }
    return null;
  }

  function getTopOverlayOffset() {
    const selectors = [
      ".header"
    ];
    const seen = new Set();
    let offset = 0;

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!el || seen.has(el)) return;
        seen.add(el);

        const styles = window.getComputedStyle(el);
        if (styles.display === "none" || styles.visibility === "hidden") return;

        const rect = el.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0) return;

        if (styles.position === "fixed" || styles.position === "sticky") {
          offset += rect.height;
        }
      });
    });

    const stickyCart = document.querySelector(".product__sticky-cart");
    if (stickyCart) {
      const stickyRect = stickyCart.getBoundingClientRect();
      if (stickyRect.height > 0) {
        offset += stickyRect.height;
      } else {
        offset += 72;
      }
    }

    return offset + EXTRA_SCROLL_GAP;
  }

  function scrollElementWithOffset(element, behavior) {
    if (!element || element.getClientRects().length === 0) return false;
    const rect = element.getBoundingClientRect();
    const offset = getTopOverlayOffset();
    const top = Math.max(0, window.scrollY + rect.top - offset);
    window.scrollTo({ top, behavior });
    return true;
  }

  function getPreferredScrollAnchor(target, ids) {
    const headingAnchor = findHeadingAnchor(ids || []);
    if (headingAnchor) return headingAnchor;

    if (!target) return target;

    const productTabsRoot = target.closest("product-tabs");
    if (productTabsRoot) {
      return productTabsRoot.querySelector(".product__tabs") || productTabsRoot;
    }

    const sectionTabsRoot = target.closest(".product-tabs");
    if (sectionTabsRoot) {
      const visibleLayout = [...sectionTabsRoot.querySelectorAll(".product-tabs__layout")].find(isVisible);
      return visibleLayout?.querySelector(".product-tabs__tabs, .product-tabs__accordion") || visibleLayout || sectionTabsRoot;
    }

    return target;
  }

  function scrollTargetElement(target, ids) {
    if (!target) return false;
    const anchor = getPreferredScrollAnchor(target, ids);

    if (scrollElementWithOffset(anchor, "smooth")) return true;

    const fallbackContainer = target.closest("product-tabs, .product-tabs, section, .shopify-section");
    if (fallbackContainer) {
      return scrollElementWithOffset(fallbackContainer, "smooth");
    }

    return false;
  }

  function scheduleStableScroll(target, ids) {
    if (!target) return;
    const anchor = getPreferredScrollAnchor(target, ids);

    let done = false;
    let debounceTimer = null;

    const doFinalScroll = () => {
      if (done) return;
      done = true;
      scrollElementWithOffset(anchor, "smooth");
      observer.disconnect();
    };

    const observer = new MutationObserver(() => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doFinalScroll, 180);
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });

    debounceTimer = setTimeout(doFinalScroll, 650);
  }

  function scrollToTarget(targetId) {
    const ids = getCandidateIds(targetId);
    if (!ids.length) return false;

    activateTabsById(ids);

    let attempts = 0;
    const maxAttempts = 24;
    const run = () => {
      attempts += 1;
      const target = findTargetElement(ids);
      if (target) {
        scheduleStableScroll(target, ids);
        return;
      }
      const accordionSummary = getSectionAccordionSummaryById(ids);
      if (accordionSummary) {
        openAccordionSummary(accordionSummary);
        scheduleStableScroll(accordionSummary, ids);
        return;
      }
      if (attempts < maxAttempts) requestAnimationFrame(run);
    };

    requestAnimationFrame(run);
    return true;
  }

  function openReviewTab(productSection) {
    for (const layout of getVisibleSectionLayouts()) {
      const tabTriggers = layout.querySelectorAll(".product-tabs__tab");
      const reviewTrigger = [...tabTriggers].find((btn) =>
        textIncludesReview(btn.textContent)
      );

      if (reviewTrigger) {
        reviewTrigger.click();
        scheduleLooxRefresh(reviewTrigger);
        scrollElementWithOffset(reviewTrigger.closest(".product-tabs__tabs") || reviewTrigger, "smooth");
        return true;
      }
    }

    const tabsRoot = productSection.querySelector("product-tabs");
    if (!tabsRoot) return false;

    const tabTriggers = tabsRoot.querySelectorAll(".product__tab--trigger");
    const reviewTrigger = [...tabTriggers].find((btn) =>
      textIncludesReview(btn.textContent)
    );

    if (!reviewTrigger) return false;
    reviewTrigger.click();
    tabsRoot.scrollIntoView({ behavior: "smooth", block: "start" });

    return true;
  }

  function openReviewAccordion(productSection) {
    const sectionAccordionSummary = getSectionAccordionSummaryByText();
    if (openAccordionSummary(sectionAccordionSummary)) {
      scrollElementWithOffset(sectionAccordionSummary, "smooth");
      return true;
    }

    const summaries = productSection.querySelectorAll(
      ".product__accordion summary.js-btn"
    );
    const reviewSummary = [...summaries].find((summary) =>
      textIncludesReview(summary.textContent)
    );

    if (!reviewSummary) return false;

    const details = reviewSummary.closest("details");
    if (details && !details.classList.contains("is-active")) {
      reviewSummary.click();
    }

    reviewSummary.scrollIntoView({ behavior: "smooth", block: "start" });

    return true;
  }

  document.addEventListener("click", (event) => {
    const directReviewControl = event.target.closest(
      ".product-tabs__tab, .product-tabs__accordion summary.js-btn, product-tabs .product__tab--trigger"
    );
    if (!isReviewControl(directReviewControl)) return;

    mountLooxReview(directReviewControl);
    syncReviewAccordionHeight(directReviewControl);
  }, true);

  document.addEventListener("click", (event) => {
    const directReviewControl = event.target.closest(
      ".product-tabs__tab, .product-tabs__accordion summary.js-btn, product-tabs .product__tab--trigger"
    );
    if (isReviewControl(directReviewControl)) {
      const isSectionAccordionSummary = directReviewControl.matches(".product-tabs__accordion summary.js-btn");
      const initialTop = isSectionAccordionSummary ? directReviewControl.getBoundingClientRect().top : null;

      scheduleLooxRefresh(directReviewControl, !isSectionAccordionSummary);

      if (isSectionAccordionSummary) {
        keepElementPosition(directReviewControl, initialTop);
      }
    }

    const trigger = event.target.closest("[data-open-reviews]");
    if (!trigger) return;

    const productSection = trigger.closest(".product__content") || document;
    const targetId = trigger.getAttribute("data-reviews-target-id");

    if (targetId && scrollToTarget(targetId)) {
      return;
    }

    const tabWasOpened = openReviewTab(productSection);
    if (tabWasOpened) return;
    openReviewAccordion(productSection);
  });
})();
